import React from 'react'
import UserLayout from '../Layouts/UserLayout'

const EBook = () => {
  return (
    <UserLayout>
        <div>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Iusto eius sunt nesciunt possimus. Inventore hic veniam reiciendis eius officia in, illum exercitationem expedita magnam explicabo similique omnis ea facilis fugit, quasi sequi atque eveniet earum? Nemo natus accusantium temporibus rerum ea iusto illo nam vitae doloribus perspiciatis animi aut, voluptas odit optio quam esse necessitatibus, similique eum eius soluta laborum fugiat. Architecto rerum exercitationem quos, qui cum provident itaque ipsam hic, sequi quod voluptatem magnam omnis assumenda fuga. Delectus, maxime quas? Debitis cum beatae unde, sunt, eius facilis repellat distinctio sapiente atque laboriosam reiciendis? Voluptas dolore recusandae repellendus autem sequi.
        </div>
    </UserLayout>
  )
}

export default EBook